import { useQuery, useQueryClient } from '@tanstack/react-query';

import { flowsheetUrl } from './api';
import { clientApi } from '@/config/axios';
import { useAuth } from '@/lib/auth/AuthContext';
export interface CareView {
  author?: string;
  collapsed_groups?: Record<string, boolean>;
  date_from?: string;
  date_to?: string;
  encounter_type?: string;
  expanded?: Record<string, boolean>;
  filter?: string;
  group?: 'month' | 'phase' | 'none';
  id: string;
  latest?: number;
  name: string;
  owner_id: string;
  search?: string;
  shared: boolean;
  sort?: string[];
  status?: string;
  version: number;
}
export function useCareViews(scope: string) {
  const { user, organization } = useAuth();
  const org = organization?.organization_id;
  const cache = useQueryClient();
  const key = ['care-views', org, user?.id, scope];
  const query = useQuery({
    queryKey: key,
    enabled: !!org,
    queryFn: async () => (await clientApi.get<CareView[]>(`${flowsheetUrl(org!)}/views/${scope}`)).data,
  });
  return {
    ...query,
    save: async (
      input: Omit<Partial<CareView>, 'id' | 'owner_id' | 'version'> & { name: string; expected_version: number },
    ) => {
      const result = await clientApi.put<CareView>(`${flowsheetUrl(org!)}/views/${scope}`, input);
      await cache.invalidateQueries({ queryKey: key });
      return result.data;
    },
  };
}
